/** Returns an array: [isValidJson, (parsedValue if valid, else null or default)] */
export const getJson = <T = unknown>(jsonStr: string, defaultValue?: T): [boolean, T | null] => {
  try {
    return [true, JSON.parse(jsonStr) as T];
  } catch {
    return [false, defaultValue !== undefined ? defaultValue : null];
  }
};

export const isJson = (jsonStr: string): boolean => {
  return getJson(jsonStr)[0];
};
